function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:10;}\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:5;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M295.4,228.7c-6.5,0-11.8-5.3-11.8-11.8v-47.2c0-6.5,5.3-11.8,11.8-11.8h96.7c-31.5-43.1-82.5-71.2-140-71.2 c-95.8,0-173.2,77.5-173.2,173.2s77.5,173.2,173.2,173.2c44.1,0,84.2-16.4,114.8-43.4c4.6-4.1,11.7-3.8,16.1,0.5l33.5,33.5 c4.8,4.8,4.5,12.6-0.5,17.1C372.6,480.1,315.2,504,252.1,504C117.4,504,8.3,395.1,8,260.4C7.7,125.7,115.6,16.9,250.3,15.9 c72.7-0.5,138.2,30.8,183.2,80.8V19.8c0-6.5,5.3-11.8,11.8-11.8h47.2c6.5,0,11.8,5.3,11.8,11.8v197.1c0,6.5-5.3,11.8-11.8,11.8 H295.4L295.4,228.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M218,254.4v11.2h-44.8v0.3l8,7.4c21,20.2,34.3,35.1,34.3,53.5c0,14.3-9,29-30.5,29c-11.5,0-21.3-4.3-28.2-10.1 l4.3-9.5c4.6,3.8,12.2,8.4,21.2,8.4c14.9,0,19.8-9.4,19.8-19.5c-0.1-15-11.6-27.9-37.1-52.1l-10.6-10.3v-8.3H218z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M243.6,328.7h-14.9l25.1-36.3l-26.4-37.9h14.9l10.7,16.7c2.7,4.5,5.3,8.5,7.8,12.9h0.3c2.6-4.5,5.1-8.6,8-12.9 l10.9-16.7h15.4l-26.1,38.3l25.3,35.9H280l-10.4-15.8c-2.5-4-4.9-7.9-7.4-12.3h-0.5c-2.4,4.1-4.7,8-7.5,12.1L243.6,328.7 L243.6,328.7z"
}));

function SvgIconRotateRight2XMirroredMirrored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRotateRight2XMirroredMirrored);
export default __webpack_public_path__ + "static/media/icon_rotate_right-2x-mirrored-mirrored.e393babc.svg";
export { ForwardRef as ReactComponent };